import PropTypes from "prop-types";
import React from "react";
import ProductDescriptionDetails from "web/react/components/product-description/product-description-details/product-description-details";
import ProductDescriptionHeader from "web/react/components/product-description/product-description-header/product-description-header";
import ProductDescriptionPrice from "web/react/components/product-description/product-description-price/product-description-price";
import Shipping from "web/react/components/shipping/shipping";
import { gettext } from "web/script/modules/django-i18n";
import userProfiler from "web/script/modules/userprofiler";
import { BuyOptionPropType } from "web/types/buy-option";
import { DesignerPropType } from "web/types/designer";
import { ProductPropType } from "web/types/product";
// Temp
// eslint-disable-next-line css-modules/no-unused-class
import pdStyle from "../product-description/product-description.css";

function ProductArea(props) {
    return (
        <div className="in-stock-affiliate-product-layout__info__details">
            <ProductDescriptionTEMP {...props} />
        </div>
    );
}

ProductArea.propTypes = {
    buy_options: PropTypes.objectOf(BuyOptionPropType).isRequired,
    product: ProductPropType.isRequired,
    designer: DesignerPropType.isRequired,
    absolute_url: PropTypes.string.isRequired,
    is_saved_for_later: PropTypes.bool.isRequired,
    sorted_buy_options: PropTypes.arrayOf(PropTypes.string).isRequired,
    lead_label: PropTypes.string.isRequired,
    terms_url: PropTypes.string.isRequired
};

function ProductDescriptionTEMP({
    buy_options: buyOptions,
    product,
    designer,
    absolute_url: absoluteUrl,
    is_saved_for_later: isSavedForLater,
    sorted_buy_options: sortedBuyOptions,
    lead_label: leadLabel,
    terms_url: termsUrl
}) {
    let buyOption = buyOptions[sortedBuyOptions[0]];
    let size = buyOption.sizes[buyOption.default_size];
    let isLoggedIn = React.useMemo(() => userProfiler.isLoggedIn(), []);

    let currentPriceHtml = size.formatted_sale_price_with_html;
    let priceWithCurrencySymbol = size.formatted_price;

    let selectedShipping;
    let freeShipping;
    if (size.shipping_info) {
        let { cheapest, cheapest_guaranteed: guaranteed } = size.shipping_info;
        if (cheapest && cheapest.is_free) {
            freeShipping = cheapest;
        }
        if (guaranteed) {
            selectedShipping = guaranteed;
        } else {
            selectedShipping = cheapest;
        }
    }
    let shippingCostLabel = "";
    if (selectedShipping && !selectedShipping.is_free) {
        shippingCostLabel = gettext("in_stock_product.shipping_cost", {
            shipping_cost: selectedShipping.formatted_price
        });
    }
    let promotion;
    if (size.promotion) {
        let promo = size.promotion;
        let retailerTerms = promo.terms_url;
        if (!retailerTerms) {
            retailerTerms = size.lead_url;
        }
        promotion = {
            tcs: [
                {
                    message: gettext("in_stock_product.lyst_promotion_terms_link"),
                    url: termsUrl
                },
                {
                    message: gettext("in_stock_product.retailer_promotion_terms_link", {
                        retailer_name: buyOption.retailer_name
                    }),
                    url: retailerTerms
                }
            ],
            message: promo.html_message,
            url: promo.url
        };
    }

    return (
        <div>
            <ProductDescriptionHeader
                absoluteUrl={absoluteUrl}
                className={pdStyle.headerArea}
                designerName={designer.name}
                designerUrl={designer.url}
                isDesignerActive={designer.active}
                productId={product.product_id}
                shortDescription={product.short_description}
            />
            <ProductDescriptionPrice
                absoluteUrl={absoluteUrl}
                className={pdStyle.priceArea}
                currentPriceHtml={currentPriceHtml}
                dateUpdated={buyOption.date_updated}
                isAmazonProduct={buyOption.is_amazon}
                isLoggedIn={isLoggedIn}
                isOnSale={size.is_on_sale}
                isSavedForLater={isSavedForLater}
                lastChecked={buyOption.date_updated_human}
                leadLabel={leadLabel}
                leadUrl={size.lead_url}
                priceWithCurrencySymbol={priceWithCurrencySymbol}
                productId={product.product_id}
                promotion={promotion}
                retailerName={buyOption.retailer_name}
                shippingCostLabel={shippingCostLabel}
            />
            {freeShipping && (
                <div className={pdStyle.shippingArea}>
                    <h4 className={pdStyle.shippingTitle}>
                        {gettext("in_stock_product.shipping_returns_label")}
                    </h4>
                    <Shipping
                        freeShippingUrl={"" /* this is always "" in monoprice_buy_option.py */}
                        isSavedForLater={isSavedForLater}
                        leadUrl={size.lead_url}
                        message={freeShipping.html_message}
                        retailerName={buyOption.retailer_name}
                    />
                </div>
            )}
            <ProductDescriptionDetails
                className={pdStyle.detailsArea}
                productDescription={product.long_description}
                productTitle={gettext("in_stock_product.details")}
            />
        </div>
    );
}

ProductDescriptionTEMP.propTypes = ProductArea.propTypes;

export default ProductArea;
